import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getMilwaukeeStructuredData() {
  const url = "https://restorehair.com/locations/wisconsin/milwaukee/";
  const description =
    "Find out about your hair transplant options in Milwaukee with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("milwaukee", url, description),
    locationPageCrumbs(url, "Milwaukee"),
  ];
}
